<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('menu.users')"
    >
      <ok-table
        ref="datatable"
        :config="config"
        @edit="handleEdit"
        @delete="handleDelete"
      >
        <template #id-column="{props}">
          <span @click="copy(props.row.id)">{{ props.row.id }}</span>
        </template>
      </ok-table>
    </empty-card>
    <update-user-modal
      v-model="showEditModal"
      :user="selectedUser"
    />
  </div>
</template>

<script>
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import AdminUsersApi from '@/api/admin/users'
import UpdateUserModal from '@/views/admin/users/components/EditUserModal'
import UsersTableConfig from './config/users-table-config'

export default {
  components: {
    UpdateUserModal,
    EmptyCard,
    OkTable,
  },
  data() {
    return {
      config: UsersTableConfig,
      showEditModal: false,
      selectedUser: {},
    }
  },
  methods: {
    refreshTable() {
      this.selectedUser = {}
      this.$refs.datatable.loadItems()
    },
    handleEdit(props = null) {
      this.showEditModal = true
      this.selectedUser = props?.row ?? null
    },
    async copy(text) {
      await navigator.clipboard.writeText(text)
      this.$notifySuccess(this.$t('general.copy-success'))
    },
    handleDelete(data) {
      const filters = this.$refs.datatable?.$data?.serverParams?.columnFilters ?? {}
      this.$okConfirm(this.$t('user.delete-user-message'), {
        preConfirm: () => (filters.page_id ? AdminUsersApi.detachPage(data.row.id, filters.page_id) : AdminUsersApi.delete(data.row.id))
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
